<template>
  <section class="customer">
    <div class="hero">
      <div class="wrapper">
        <h1 class="intro-title">Rees Solutions Customer Attributes</h1>
        <article class="intro-text">Clear, concise and complete customer data can make the difference between running a good ecommerce business, and a great ecommerce business. Customers feel valued by suppliers who know their clients and offer products and services that meet their needs.</article>
      </div>
    </div>
    <div class="content">
      <div class="wrapper">
        <h2 class="module-title"><a :href="link_href" title="Customer Attributes">Get It On Magento Marketplace!</a></h2>
        <div class="modules_grid">
          <div id="info" class="module">
            <h3>Why use a Customer Attributes extension?</h3>
            <p>Having incomplete data leaves store owners seeing only part of the picture, and left guessing who their customers are and what they need – leaving businesses falling short on customer satisfaction and sales opportunities.<br/>
            This is even more of a challenge when store owners are running multi-stores and require the ability to customise data collection in local formats taking regional and language variations into account. Customers want assurances when sharing their data with businesses and feel that their data is in safe hands, so using forms that are familiar to customers based on local or country-specific formats is essential in running successful multi-site stores.<br/>
            With Magneto 2, the functionality in the default install is limited, and does not give store owners the flexibility to adapt how data is collected to meet today’s modern, fast moving and highly competitive digital marketplace, and many cannot afford the expenditure associated with custom developments.<br/>
            The Rees Solutions Customer Attribute Extension is the solution for all customer data and address localization needs.
            </p>
          </div>
          <div id="features" class="module">
            <h3>Our Feature Set</h3>
            <ul>
              <li>Customer and address attribute system control</li>
              <li>Gives store owners control over the customer name</li>
              <li>Options for adding extra name fields such as the dutch tussenvoegsel</li>
              <li>Custom name fields are added to the default emails</li>
              <li>Adds the custom address fields to the order api</li>
              <li>Automated address field sorting on all default customer account forms</li>
              <li>Admin attribute grids for the customer and the address attributes</li>
              <li>Field length and regular expression pattern validation options in the admin</li>
              <li>Multi-store Compatibility</li>
              <li>Allows the store owner to set up a custom checkout address template with no file editing required</li>
              <li>Allows the creation of new text, text area, Yes/No, dropdown and multiselect attributes</li>
              <li>Extension documentation available in the administration console</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CustomerAttributes',
  data () {
    return {
      msg: 'Customer Attributes',
      para: [
        { text: 'Customer Data is key to your growth, deliverability and understanding what your customers need. The clarity, completness and accuracy of this data is the difference between a good and a great ecommerce business. Why use the standard address format in Magento when your target audience is used to a different one in every other part of their lives? With the open source version of Magento of course you didn\'t have a choice but now you do.' },
        { text: 'The Customer Attributes Extension by Rees Solutions gives you the opportunity to get more data from your customers in the way they are used to.' }
      ],
      para_last: 'Availability details coming soon!',
      link_href: 'https://marketplace.magento.com/reessolutions-customerattributes.html'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
ul {
  color: #646464;
  list-style: "\276F ";
  margin-left: 28px;
}
/*@counter-style rslm {
  system: fixed;
  symbols: url('/static/rees-solutions-logo-black.svg');
  suffix: " ";
}*/
</style>



// WEBPACK FOOTER //
// src/components/CustomerAttributes.vue